import { render, staticRenderFns } from "./UserInventionList.vue?vue&type=template&id=32b5a0f7"
import script from "./UserInventionList.vue?vue&type=script&lang=js"
export * from "./UserInventionList.vue?vue&type=script&lang=js"
import style0 from "./UserInventionList.vue?vue&type=style&index=0&id=32b5a0f7&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32b5a0f7')) {
      api.createRecord('32b5a0f7', component.options)
    } else {
      api.reload('32b5a0f7', component.options)
    }
    module.hot.accept("./UserInventionList.vue?vue&type=template&id=32b5a0f7", function () {
      api.rerender('32b5a0f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/UserInventionList.vue"
export default component.exports